import { ChangeDetectionStrategy, Component, computed, input, ResourceRef } from '@angular/core'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { trackResourceFailure } from '../../services/resource-failure'
import { ErrorStateComponent } from '../error-state/error-state.component'

/**
 * Zeigt einen Ladebalken, solange Resourcen laden, den Fehlerzustand, wenn eine davon
 * fehlgeschlagen ist, und sonst den projizierten Inhalt.
 *
 * Der Fehlerzustand ist `lib-error-state`: er benennt die Ursache und bietet einen
 * Wiederholen-Knopf an, statt einen Browser-Reload zu verlangen (der wirft in einem halb
 * ausgefuellten Assistenten die Arbeit weg). Kommt SaniUp von allein zurueck, laedt die
 * Komponente ohne Zutun nach — siehe `trackResourceFailure`.
 */
@Component({
  selector: 'lib-resource-loading',
  imports: [MatProgressBarModule, ErrorStateComponent],
  templateUrl: './resource-loading.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './resource-loading.component.scss',
})
export class ResourceLoadingComponent {
  readonly staticLoad = input(false)
  readonly resources = input<ResourceRef<unknown>[]>([])

  readonly failure = trackResourceFailure(() => this.resources())

  readonly anyIsLoading = computed(() => this.resources().some((r) => r.status() === 'loading' || r.status() === 'reloading'))
}
